export default __webpack_public_path__ + "6c2a9ba9544fc8daa48983141643fb0b.svg";